import { Capacitor } from "@capacitor/core";
import { BallEvent } from "../types/cricket";
export const APP_NAME = "Cricket Score Counter";
// Client-side gate is UX only (hides the nav link / redirects away
// quickly) -- the real access control is enforced server-side, which
// rejects anyone whose email isn't in ANALYTICS_ADMIN_EMAILS with a 403.
export const ADMIN_ANALYTICS_EMAIL = "gotimonik@gmail.com";
const DEFAULT_SITE_URL = "https://www.cricket-score-counter.com";
const RAW_SITE_URL = (
  process.env.REACT_APP_SITE_URL || DEFAULT_SITE_URL
).trim();

const normalizeSiteUrl = (input: string): string => {
  const withProtocol = /^https?:\/\//i.test(input) ? input : `https://${input}`;
  try {
    const parsed = new URL(withProtocol);
    if (parsed.hostname === "cricket-score-counter.com") {
      parsed.hostname = "www.cricket-score-counter.com";
    }
    return parsed.toString().replace(/\/+$/, "");
  } catch {
    return DEFAULT_SITE_URL;
  }
};

export const APP_URL = normalizeSiteUrl(RAW_SITE_URL);
export const ANDROID_APP_URL = (
  process.env.REACT_APP_ANDROID_APP_URL ||
  "https://play.google.com/store/apps/details?id=com.cricketscorecounter.mobile"
).trim();
export const IOS_APP_URL = (
  process.env.REACT_APP_IOS_APP_URL ||
  "https://apps.apple.com/us/app/cricket-score-counter/id6819157368?ppid=2325bc62-5906-41a3-bda4-c70f89b0dae7"
).trim();
// AdMob ad units belong to ONE platform's app in AdMob, so iOS has its own
// IDs (the iOS AdMob app ID itself is ADMOB_APP_ID in the Xcode project).
// If an iOS unit isn't set in .env, that ad type is simply not shown on iOS
// rather than falling back to Android units AdMob would never fill.
const isIosApp = Capacitor.getPlatform() === "ios";
const envId = (value?: string) => (value || "").trim() || undefined;

export const ADMOB_BANNER_AD_ID = isIosApp
  ? envId(process.env.REACT_APP_ADMOB_IOS_BANNER_AD_ID)
  : envId(process.env.REACT_APP_ADMOB_BANNER_AD_ID);
export const ADMOB_INTERSTITIAL_AD_ID = isIosApp
  ? envId(process.env.REACT_APP_ADMOB_IOS_INTERSTITIAL_AD_ID)
  : envId(process.env.REACT_APP_ADMOB_INTERSTITIAL_AD_ID);
export const APP_VERSION = "1.0.3";
export const EXTRA_PLAYER_NAME = "Extra Player (Dummy)";
export const scoringOptions: BallEvent[] = [
  {
    type: "run",
    value: 0,
  },
  {
    type: "run",
    value: 1,
  },
  {
    type: "run",
    value: 2,
  },
  {
    type: "run",
    value: 4,
  },
  {
    type: "run",
    value: 6,
  },
  {
    type: "wide",
    value: 1,
  },
  {
    type: "no-ball",
    value: 1,
  },
  {
    type: "wicket",
    value: 0,
  },
];

export const moreScoringOptions: BallEvent[] = [
  {
    type: "run",
    value: 3,
  },
  {
    type: "bye",
    value: 3,
  },
  {
    type: "leg-bye",
    value: 3,
  },
  {
    type: "run",
    value: 5,
  },
  {
    type: "penalty",
    value: 5,
  },
];

export const noBallScoringOptions: BallEvent[] = [
  {
    type: "run",
    value: 0,
  },
  {
    type: "run",
    value: 1,
  },
  {
    type: "run",
    value: 2,
  },
  {
    type: "run",
    value: 4,
  },
  {
    type: "run",
    value: 6,
  },
  {
    type: "wicket",
    value: 0,
  },
];

export const SocketIOServerEvents = {
  CONNECT: "connect",
  DISCONNECT: "disconnect",
  MESSAGE: "message",
  ERROR: "error",
  LIVE_UPDATES: "LIVE_UPDATES",
  GAME_STARTED: "GAME_STARTED",
  GAME_SCORED: "GAME_SCORED",
  GAME_SCORE_UPDATED: "GAME_SCORE_UPDATED",
  // Not emitted by the backend yet -- the Home page falls back to a
  // simulated count until the server starts broadcasting this event.
  ACTIVE_USERS_COUNT: "ACTIVE_USERS_COUNT",
};
export const SocketIOClientEvents = {
  GAME_JOIN: "GAME_JOIN",
  GAME_END: "GAME_END",
  GAME_SCORE_UPDATE: "GAME_SCORE_UPDATE",
  HOME_PAGE_VIEW: "HOME_PAGE_VIEW",
};
